module.exports = __webpack_public_path__ + "img/10.706a9998.png";